/* Uttariya Theme JS */
(function () {
  'use strict';

  /* ── Header scroll ── */
  var hdr = document.querySelector('.site-header');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── Mobile nav ── */
  var burger   = document.getElementById('Burger');
  var mobBg    = document.getElementById('MobBg');
  var mobPanel = document.getElementById('MobPanel');
  var mobClose = document.getElementById('MobClose');
  function openNav()  { if (!mobPanel) return; mobPanel.classList.add('open');    if (mobBg) mobBg.classList.add('open');    document.body.style.overflow = 'hidden'; }
  function closeNav() { if (!mobPanel) return; mobPanel.classList.remove('open'); if (mobBg) mobBg.classList.remove('open'); document.body.style.overflow = ''; }
  if (burger)   burger.addEventListener('click', openNav);
  if (mobClose) mobClose.addEventListener('click', closeNav);
  if (mobBg)    mobBg.addEventListener('click', closeNav);

  document.querySelectorAll('.mob-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.classList.toggle('open');
      var sub = btn.closest('li').querySelector('.mob-sub');
      if (sub) sub.classList.toggle('open');
    });
  });

  /* ── Search ── */
  var searchBtn   = document.getElementById('SearchBtn');
  var searchBg    = document.getElementById('SearchBg');
  var searchClose = document.getElementById('SearchClose');
  var searchInput = document.getElementById('SearchInput');
  function openSearch()  { if (!searchBg) return; searchBg.classList.add('open');    if (searchInput) setTimeout(function () { searchInput.focus(); }, 60); }
  function closeSearch() { if (searchBg)  searchBg.classList.remove('open'); }
  if (searchBtn)   searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchBg)    searchBg.addEventListener('click', function (e) { if (e.target === searchBg) closeSearch(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeNav(); closeSearch(); closeLightbox(); closeCtxMenu(); }
  });

  /* ── Hero slider ── */
  var heroSlides = document.getElementById('HeroSlides');
  var heroDots   = document.querySelectorAll('.hero-dot');
  var heroPrev   = document.getElementById('HeroPrev');
  var heroNext   = document.getElementById('HeroNext');
  if (heroSlides && heroDots.length > 1) {
    var hCur = 0, hTotal = heroDots.length;
    function hGo(idx) {
      hCur = (idx + hTotal) % hTotal;
      heroSlides.style.transform = 'translateX(-' + (hCur * 100) + '%)';
      heroDots.forEach(function (d, i) { d.classList.toggle('on', i === hCur); });
    }
    if (heroPrev) heroPrev.addEventListener('click', function () { hGo(hCur - 1); });
    if (heroNext) heroNext.addEventListener('click', function () { hGo(hCur + 1); });
    heroDots.forEach(function (d) { d.addEventListener('click', function () { hGo(+d.dataset.i); }); });
    var hTimer = setInterval(function () { hGo(hCur + 1); }, 4000);
    heroSlides.parentElement.addEventListener('mouseenter', function () { clearInterval(hTimer); });
    heroSlides.parentElement.addEventListener('mouseleave', function () { hTimer = setInterval(function () { hGo(hCur + 1); }, 4000); });
    var hTx = 0;
    heroSlides.addEventListener('touchstart', function (e) { hTx = e.touches[0].clientX; }, { passive: true });
    heroSlides.addEventListener('touchend',   function (e) { var dx = e.changedTouches[0].clientX - hTx; if (Math.abs(dx) > 40) hGo(dx < 0 ? hCur + 1 : hCur - 1); }, { passive: true });
  }

  /* ── Featured products carousel ── */
  document.querySelectorAll('.fp-instance').forEach(function (fp) {
    var track = fp.querySelector('.fp-track');
    var prev  = fp.querySelector('.fp-prev');
    var next  = fp.querySelector('.fp-next');
    var dotsC = fp.querySelector('.fp-dots');
    if (!track) return;
    var cur = 0, dots = [], SHOW = 2;
    function allCards() { return Array.from(track.querySelectorAll('.pcard')); }
    function cardW()    { var c = allCards()[0]; return c ? c.offsetWidth + 12 : 0; }
    function maxI()     { return Math.max(0, allCards().length - SHOW); }
    function buildDots() {
      dotsC.innerHTML = ''; dots = [];
      if (window.innerWidth >= 768) return;
      for (var i = 0; i <= maxI(); i++) {
        var d = document.createElement('button');
        d.className = 'fp-dot' + (i === 0 ? ' on' : '');
        d.setAttribute('aria-label', 'Page ' + (i + 1));
        (function (idx) { d.addEventListener('click', function () { goTo(idx); }); }(i));
        dotsC.appendChild(d); dots.push(d);
      }
    }
    function goTo(idx) {
      if (window.innerWidth >= 768) return;
      cur = Math.min(Math.max(idx, 0), maxI());
      track.style.transform = 'translateX(-' + (cur * cardW()) + 'px)';
      if (prev) prev.disabled = cur === 0;
      if (next) next.disabled = cur >= maxI();
      dots.forEach(function (d, i) { d.classList.toggle('on', i === cur); });
    }
    if (prev) prev.addEventListener('click', function () { goTo(cur - 1); });
    if (next) next.addEventListener('click', function () { goTo(cur + 1); });
    var tx = 0;
    track.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend',   function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40) goTo(dx < 0 ? cur + 1 : cur - 1); }, { passive: true });
    function reset() {
      if (window.innerWidth >= 768) {
        track.style.transform = ''; dotsC.innerHTML = '';
        if (prev) prev.style.display = 'none';
        if (next) next.style.display = 'none';
      } else {
        if (prev) prev.style.display = '';
        if (next) next.style.display = '';
        buildDots(); goTo(0);
      }
    }
    reset();
    window.addEventListener('resize', reset, { passive: true });
  });

  /* ── Footer accordion ── */
  document.querySelectorAll('.ft-col-head').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth >= 600) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !open);
      var body = btn.nextElementSibling;
      if (body) body.classList.toggle('open', !open);
    });
  });

  /* ── Product page gallery ── */
  var mainImg = document.getElementById('PdpMain');
  if (mainImg) {
    document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
        mainImg.src = thumb.dataset.full;
        mainImg.srcset = '';
      });
    });
  }

  /* ============================================================
     IMAGE ZOOM  +  RIGHT-CLICK CONTEXT MENU
     Fixed issues:
     1. "Open in new tab" uses a real <a> tag — works natively
     2. "Copy image" uses fetch → blob → ClipboardItem API
     3. Image detection fixed: walk up from e.target correctly
     4. pointer-events restored on img so clicks register
     5. contextmenu only preventDefault when custom menu shown
     ============================================================ */

  /* ── Helpers ── */
  function getImgFromTarget(target) {
    /* Walk up the DOM from the clicked element to find an img */
    var el = target;
    while (el && el !== document.body) {
      if (el.tagName === 'IMG') return el;
      /* If el is a known image container, look inside */
      if (
        el.classList.contains('pdp-main-img') ||
        el.classList.contains('pcard-img')    ||
        el.classList.contains('cat-tile')     ||
        el.classList.contains('hero-slide')   ||
        el.classList.contains('story-img')    ||
        el.classList.contains('utt-zoom-wrap')
      ) {
        var found = el.querySelector('img');
        if (found) return found;
      }
      el = el.parentElement;
    }
    return null;
  }

  function isProductImage(img) {
    if (!img) return false;
    var p = img.parentElement;
    while (p && p !== document.body) {
      if (
        p.classList.contains('pdp-main-img') ||
        p.classList.contains('pcard-img')    ||
        p.classList.contains('cat-tile')     ||
        p.classList.contains('hero-slide')   ||
        p.classList.contains('story-img')
      ) return true;
      p = p.parentElement;
    }
    return false;
  }

  /* Get the best-quality src from an img (prefer data-full or srcset largest) */
  function getBestSrc(img) {
    if (!img) return '';
    if (img.dataset.full) return img.dataset.full;
    /* Try to get largest srcset entry */
    if (img.srcset) {
      var parts = img.srcset.split(',').map(function (s) { return s.trim().split(/\s+/); });
      var best = parts.reduce(function (a, b) {
        var aw = parseInt(a[1]) || 0;
        var bw = parseInt(b[1]) || 0;
        return bw > aw ? b : a;
      }, parts[0]);
      if (best && best[0]) return best[0];
    }
    return img.src || '';
  }

  /* Copy image to clipboard using fetch + ClipboardItem */
  function copyImageToClipboard(src, fallbackUrl) {
    if (!src) return;
    /* ClipboardItem API (Chrome 97+, not Firefox) */
    if (window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
      fetch(src)
        .then(function (r) { return r.blob(); })
        .then(function (blob) {
          var type = blob.type || 'image/png';
          var item = new ClipboardItem({ [type]: blob });
          return navigator.clipboard.write([item]);
        })
        .then(function () { showToast('Image copied to clipboard'); })
        .catch(function () {
          /* Fallback: copy the URL instead */
          if (navigator.clipboard) {
            navigator.clipboard.writeText(fallbackUrl || src)
              .then(function () { showToast('Image URL copied'); })
              .catch(function () {});
          }
        });
    } else if (navigator.clipboard) {
      /* Firefox fallback — copy URL */
      navigator.clipboard.writeText(fallbackUrl || src)
        .then(function () { showToast('Image URL copied'); })
        .catch(function () {});
    }
  }

  /* Small toast notification */
  var toastEl = null;
  var toastTimer = null;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.style.cssText = [
        'position:fixed', 'bottom:32px', 'left:50%', 'transform:translateX(-50%)',
        'background:#1a1008', 'color:#c8a96e', 'font-family:\'DM Sans\',sans-serif',
        'font-size:12px', 'letter-spacing:1px', 'padding:10px 20px',
        'z-index:99999', 'pointer-events:none', 'opacity:0',
        'transition:opacity 0.2s ease', 'white-space:nowrap'
      ].join(';');
      document.body.appendChild(toastEl);
    }
    clearTimeout(toastTimer);
    toastEl.textContent = msg;
    toastEl.style.opacity = '1';
    toastTimer = setTimeout(function () { toastEl.style.opacity = '0'; }, 2200);
  }

  /* ── Lightbox ── */
  var lb = null, lbImg = null;
  var lbScale = 1, lbMinScale = 1, lbMaxScale = 4;
  var lbPanX = 0, lbPanY = 0;
  var lbDragging = false;
  var lbDragStartX = 0, lbDragStartY = 0, lbPanStartX = 0, lbPanStartY = 0;
  var lbTouchDist = 0, lbTouchScaleStart = 1, lbTouchMidX = 0, lbTouchMidY = 0;

  function lbApplyTransform() {
    if (!lbImg) return;
    lbImg.style.transform = 'translate(' + lbPanX + 'px,' + lbPanY + 'px) scale(' + lbScale + ')';
    var el = document.querySelector('.utt-lb-zoom-level');
    if (el) el.textContent = Math.round(lbScale * 100) + '%';
  }

  function lbClampPan() {
    if (!lbImg) return;
    var rw = lbImg.offsetWidth, rh = lbImg.offsetHeight;
    var sw = rw * lbScale,      sh = rh * lbScale;
    var maxPx = Math.max(0, (sw - rw) / 2);
    var maxPy = Math.max(0, (sh - rh) / 2);
    if (sw <= rw) lbPanX = 0; else lbPanX = Math.min(maxPx, Math.max(-maxPx, lbPanX));
    if (sh <= rh) lbPanY = 0; else lbPanY = Math.min(maxPy, Math.max(-maxPy, lbPanY));
  }

  function lbZoom(factor, cx, cy) {
    var prev = lbScale;
    lbScale = Math.min(lbMaxScale, Math.max(lbMinScale, lbScale * factor));
    if (lbScale === prev) return;
    var ratio = lbScale / prev - 1;
    lbPanX -= (cx || 0) * ratio;
    lbPanY -= (cy || 0) * ratio;
    lbClampPan(); lbApplyTransform();
  }

  function openLightbox(src, alt) {
    if (!lb) buildLightbox();
    lbImg.src = src; lbImg.alt = alt || '';
    lbScale = 1; lbPanX = 0; lbPanY = 0;
    lbApplyTransform();
    lb.style.display = 'flex';
    requestAnimationFrame(function () { lb.classList.add('open'); });
    document.body.style.overflow = 'hidden';
    /* Update open-in-new-tab link */
    var newTabLink = lb.querySelector('.utt-lb-newtab');
    if (newTabLink) newTabLink.href = src;
  }

  function closeLightbox() {
    if (!lb) return;
    lb.classList.remove('open');
    setTimeout(function () { lb.style.display = 'none'; document.body.style.overflow = ''; }, 260);
  }

  function buildLightbox() {
    lb = document.createElement('div');
    lb.className = 'utt-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.style.display = 'none';

    var inner = document.createElement('div');
    inner.className = 'utt-lightbox-inner';
    lbImg = document.createElement('img');
    lbImg.draggable = false;
    inner.appendChild(lbImg);
    lb.appendChild(inner);

    /* Close button */
    var closeBtn = document.createElement('button');
    closeBtn.className = 'utt-lb-close';
    closeBtn.setAttribute('aria-label', 'Close zoom');
    closeBtn.innerHTML = '&#x2715;';
    closeBtn.addEventListener('click', closeLightbox);
    lb.appendChild(closeBtn);

    /* Open in new tab — real <a> tag so browser handles it natively */
    var newTabLink = document.createElement('a');
    newTabLink.className = 'utt-lb-newtab';
    newTabLink.target = '_blank';
    newTabLink.rel = 'noopener noreferrer';
    newTabLink.setAttribute('aria-label', 'Open image in new tab');
    newTabLink.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" fill="none" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>';
    newTabLink.style.cssText = 'position:fixed;top:16px;right:56px;background:none;border:none;color:#c8a96e;cursor:pointer;z-index:9001;line-height:1;padding:4px 8px;display:flex;align-items:center;';
    lb.appendChild(newTabLink);

    /* Zoom bar */
    var bar = document.createElement('div');
    bar.className = 'utt-lb-zoom-bar';
    var btnOut = document.createElement('button');
    btnOut.className = 'utt-lb-zoom-btn'; btnOut.innerHTML = '&#x2212;'; btnOut.setAttribute('aria-label','Zoom out');
    btnOut.addEventListener('click', function () { lbZoom(0.75,0,0); });
    var lvl = document.createElement('span'); lvl.className = 'utt-lb-zoom-level'; lvl.textContent = '100%';
    var btnIn = document.createElement('button');
    btnIn.className = 'utt-lb-zoom-btn'; btnIn.innerHTML = '&#x2b;'; btnIn.setAttribute('aria-label','Zoom in');
    btnIn.addEventListener('click', function () { lbZoom(1.33,0,0); });
    var hint = document.createElement('span'); hint.className = 'utt-lb-hint';
    hint.textContent = window.innerWidth < 768 ? 'Pinch to zoom' : 'Scroll · Drag to pan';
    bar.appendChild(btnOut); bar.appendChild(lvl); bar.appendChild(btnIn); bar.appendChild(hint);
    lb.appendChild(bar);

    /* Scroll to zoom */
    lb.addEventListener('wheel', function (e) {
      e.preventDefault();
      var rect = lbImg.getBoundingClientRect();
      lbZoom(e.deltaY < 0 ? 1.15 : 0.87, e.clientX - rect.left - rect.width/2, e.clientY - rect.top - rect.height/2);
    }, { passive: false });

    /* Drag to pan (desktop) */
    lb.addEventListener('mousedown', function (e) {
      if (e.target.closest('button, a')) return;
      if (lbScale <= 1) return;
      lbDragging = true; lb.classList.add('dragging');
      lbDragStartX = e.clientX; lbDragStartY = e.clientY;
      lbPanStartX = lbPanX;    lbPanStartY = lbPanY;
      e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!lbDragging) return;
      lbPanX = lbPanStartX + (e.clientX - lbDragStartX);
      lbPanY = lbPanStartY + (e.clientY - lbDragStartY);
      lbClampPan(); lbApplyTransform();
    });
    window.addEventListener('mouseup', function () { lbDragging = false; lb && lb.classList.remove('dragging'); });

    /* Double-click to zoom/reset */
    inner.addEventListener('dblclick', function (e) {
      var rect = lbImg.getBoundingClientRect();
      var cx = e.clientX - rect.left - rect.width/2;
      var cy = e.clientY - rect.top - rect.height/2;
      if (lbScale > 1.5) { lbScale=1; lbPanX=0; lbPanY=0; lbApplyTransform(); }
      else { lbZoom(2, cx, cy); }
    });

    /* Pinch to zoom (mobile) */
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        lbTouchDist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY);
        lbTouchScaleStart = lbScale;
        lbTouchMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        lbTouchMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
      } else if (e.touches.length === 1 && lbScale > 1) {
        lbDragging = true;
        lbDragStartX = e.touches[0].clientX; lbDragStartY = e.touches[0].clientY;
        lbPanStartX = lbPanX; lbPanStartY = lbPanY;
      }
    }, { passive: false });
    lb.addEventListener('touchmove', function (e) {
      e.preventDefault();
      if (e.touches.length === 2) {
        var dist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY);
        lbScale = Math.min(lbMaxScale, Math.max(lbMinScale, lbTouchScaleStart * (dist / lbTouchDist)));
        lbClampPan(); lbApplyTransform();
      } else if (e.touches.length === 1 && lbDragging) {
        lbPanX = lbPanStartX + (e.touches[0].clientX - lbDragStartX);
        lbPanY = lbPanStartY + (e.touches[0].clientY - lbDragStartY);
        lbClampPan(); lbApplyTransform();
      }
    }, { passive: false });
    lb.addEventListener('touchend', function () { lbDragging = false; }, { passive: true });

    /* Click overlay to close */
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });

    document.body.appendChild(lb);
  }

  /* ── Init zoom on product images ── */
  function initZoom() {
    var pdpWrap = document.querySelector('.pdp-main-img');
    if (pdpWrap) {
      var pdpMainImg = pdpWrap.querySelector('img');
      if (pdpMainImg) {
        /* Restore pointer-events so img is clickable */
        pdpMainImg.style.pointerEvents = 'auto';
        pdpWrap.classList.add('utt-zoom-wrap');
        var hint = document.createElement('span');
        hint.className = 'utt-zoom-hint';
        hint.textContent = window.innerWidth < 768 ? 'Tap to zoom' : 'Click to zoom';
        pdpWrap.appendChild(hint);
        pdpWrap.addEventListener('click', function (e) {
          if (e.target.classList.contains('utt-zoom-hint')) return;
          openLightbox(getBestSrc(pdpMainImg), pdpMainImg.alt);
        });
        document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var newSrc = thumb.dataset.full || (thumb.querySelector('img') && thumb.querySelector('img').src);
            if (lbImg && newSrc) lbImg.src = newSrc;
            var newTabLink = lb && lb.querySelector('.utt-lb-newtab');
            if (newTabLink && newSrc) newTabLink.href = newSrc;
          });
        });
      }
    }
    document.querySelectorAll('.pcard-img').forEach(function (wrap) {
      var img = wrap.querySelector('img');
      if (!img) return;
      img.style.pointerEvents = 'auto';
      wrap.style.cursor = 'zoom-in';
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('.pcard-qa')) return;
        openLightbox(getBestSrc(img), img.alt);
      });
    });
  }

  /* ── Context menu ── */
  var ctxMenu = null;

  function closeCtxMenu() {
    if (!ctxMenu) return;
    ctxMenu.classList.remove('open');
    setTimeout(function () { if (ctxMenu) ctxMenu.style.display = 'none'; }, 150);
  }

  function buildCtxMenu() {
    ctxMenu = document.createElement('div');
    ctxMenu.className = 'utt-ctx-menu';
    ctxMenu.setAttribute('role', 'menu');
    ctxMenu.style.display = 'none';
    document.body.appendChild(ctxMenu);
  }

  var ICONS = {
    zoom:    '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
    newtab:  '<svg viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>',
    copyimg: '<svg viewBox="0 0 24 24"><rect x="8" y="8" width="13" height="13" rx="2"/><path d="M4 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v1"/><polyline points="8 3 8 8"/></svg>',
    copyurl: '<svg viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>',
    share:   '<svg viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>',
    back:    '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>',
    top:     '<svg viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"/></svg>',
    reload:  '<svg viewBox="0 0 24 24"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>'
  };

  /* Build a context menu item — use <a> for new-tab so browser handles it */
  function makeItem(icon, label, action, href, target) {
    var el;
    if (href) {
      /* Real anchor — browser "open in new tab" works on middle-click too */
      el = document.createElement('a');
      el.href = href;
      el.target = target || '_blank';
      el.rel = 'noopener noreferrer';
      el.setAttribute('role', 'menuitem');
      el.innerHTML = icon + '<span>' + label + '</span>';
      el.className = 'utt-ctx-item';
      el.addEventListener('click', function () { closeCtxMenu(); });
    } else {
      el = document.createElement('button');
      el.className = 'utt-ctx-item';
      el.setAttribute('role', 'menuitem');
      el.innerHTML = icon + '<span>' + label + '</span>';
      el.addEventListener('click', function () { closeCtxMenu(); if (action) action(); });
    }
    return el;
  }

  function makeSep() {
    var s = document.createElement('div'); s.className = 'utt-ctx-sep'; return s;
  }

  function showCtxMenu(x, y, buildFn) {
    if (!ctxMenu) buildCtxMenu();
    ctxMenu.innerHTML = '';
    var lbl = document.createElement('div');
    lbl.className = 'utt-ctx-label'; lbl.textContent = 'Uttariya';
    ctxMenu.appendChild(lbl);
    ctxMenu.appendChild(makeSep());
    buildFn(ctxMenu);
    ctxMenu.style.display = 'block';
    /* Measure then position with edge clamping */
    var mw = ctxMenu.offsetWidth  || 210;
    var mh = ctxMenu.offsetHeight || 220;
    ctxMenu.style.left = (x + mw > window.innerWidth  ? x - mw : x) + 'px';
    ctxMenu.style.top  = (y + mh > window.innerHeight ? y - mh : y) + 'px';
    requestAnimationFrame(function () { ctxMenu.classList.add('open'); });
  }

  /* ── Right-click handler ── */
  document.addEventListener('contextmenu', function (e) {
    closeCtxMenu();

    var img = getImgFromTarget(e.target);

    if (img && isProductImage(img)) {
      /* Product image right-click */
      e.preventDefault();
      var src = getBestSrc(img);
      showCtxMenu(e.clientX, e.clientY, function (menu) {
        menu.appendChild(makeItem(ICONS.zoom,    'Zoom image',          function () { openLightbox(src, img.alt); }));
        /* Open in new tab — real <a> */
        menu.appendChild(makeItem(ICONS.newtab,  'Open image in new tab', null, src, '_blank'));
        menu.appendChild(makeItem(ICONS.copyimg, 'Copy image',          function () { copyImageToClipboard(src, src); }));
        menu.appendChild(makeItem(ICONS.copyurl, 'Copy image URL',      function () {
          if (navigator.clipboard) navigator.clipboard.writeText(src).then(function () { showToast('URL copied'); }).catch(function () {});
        }));
        menu.appendChild(makeSep());
        menu.appendChild(makeItem(ICONS.share,   'Share this product',  function () {
          if (navigator.share) navigator.share({ title: document.title, url: window.location.href }).catch(function(){});
          else if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).then(function () { showToast('Link copied'); }).catch(function(){});
        }));
        menu.appendChild(makeSep());
        menu.appendChild(makeItem(ICONS.back,    'Go back',             function () { window.history.back(); }));
        menu.appendChild(makeItem(ICONS.top,     'Scroll to top',       function () { window.scrollTo({ top:0, behavior:'smooth' }); }));
        menu.appendChild(makeItem(ICONS.reload,  'Reload page',         function () { window.location.reload(); }));
      });
      return;
    }

    /* General right-click — no preventDefault so browser copy/paste still works */
    e.preventDefault();
    showCtxMenu(e.clientX, e.clientY, function (menu) {
      menu.appendChild(makeItem(ICONS.back,    'Go back',             function () { window.history.back(); }));
      menu.appendChild(makeItem(ICONS.top,     'Scroll to top',       function () { window.scrollTo({ top:0, behavior:'smooth' }); }));
      menu.appendChild(makeItem(ICONS.reload,  'Reload page',         function () { window.location.reload(); }));
      menu.appendChild(makeSep());
      menu.appendChild(makeItem(ICONS.share,   'Share this page',     function () {
        if (navigator.share) navigator.share({ title: document.title, url: window.location.href }).catch(function(){});
        else if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).then(function () { showToast('Link copied'); }).catch(function(){});
      }));
      menu.appendChild(makeItem(ICONS.copyurl, 'Copy page link',      function () {
        if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).then(function () { showToast('Link copied'); }).catch(function(){});
      }));
    });
  });

  document.addEventListener('click',  function (e) { if (ctxMenu && !ctxMenu.contains(e.target)) closeCtxMenu(); });
  document.addEventListener('scroll', closeCtxMenu, { passive: true });

  /* ── Mobile long-press → context menu ── */
  var lpTimer = null, lpX = 0, lpY = 0, lpMoved = false;
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    lpX = e.touches[0].clientX; lpY = e.touches[0].clientY; lpMoved = false;
    lpTimer = setTimeout(function () {
      if (lpMoved) return;
      var el = document.elementFromPoint(lpX, lpY);
      if (el) el.dispatchEvent(new MouseEvent('contextmenu', { bubbles:true, cancelable:true, clientX:lpX, clientY:lpY }));
    }, 600);
  }, { passive: true });
  document.addEventListener('touchmove',   function (e) { if (Math.abs(e.touches[0].clientX-lpX)>8||Math.abs(e.touches[0].clientY-lpY)>8) { lpMoved=true; clearTimeout(lpTimer); } }, { passive: true });
  document.addEventListener('touchend',    function () { clearTimeout(lpTimer); }, { passive: true });
  document.addEventListener('touchcancel', function () { clearTimeout(lpTimer); }, { passive: true });

  /* ── Load zoom CSS then init ── */
  var zoomLink = document.createElement('link');
  zoomLink.rel = 'stylesheet';
  var themeCss = document.querySelector('link[href*="theme.css"]');
  zoomLink.href = themeCss ? themeCss.href.replace('theme.css','image-zoom.css') : '/assets/image-zoom.css';
  document.head.appendChild(zoomLink);

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initZoom); }
  else { initZoom(); }

}());
